import Operation from "../index.js";

export default {
  // userToken
  getToken(params, fn) {
    Operation.Http.post(`/pano/getToken?channelId=${params.channelId}&userId=${params.userId}`, null, fn)
  },
  
  
}


// WEBPACK FOOTER //
// ./src/request/api/pano.js